webpackJsonp([54],{

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportTenant_vue__ = __webpack_require__(722);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4af4d939_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportTenant_vue__ = __webpack_require__(886);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportTenant_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4af4d939_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportTenant_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(498), __esModule: true };

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(57);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(36);
__webpack_require__(25);
module.exports = __webpack_require__(499);


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var get = __webpack_require__(58);
module.exports = __webpack_require__(1).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export syncApi */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asyncApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



var _this = this;




var _guardCallback = function _guardCallback(arg) {
  if (typeof arg === "function") {
    arg();
  }
};

var _onError = function _onError(error) {
  if (error.response) {
    if (error.response.data.errors) {
      if (Array.isArray(error.response.data.errors)) {
        for (var index = 0; index < error.response.data.errors.length; index++) {
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[index], {
            title: "Error"
          });
        }
      } else {
        for (var prop in error.response.data.errors) {
          if (!error.response.data.errors.hasOwnProperty(prop)) {
            continue;
          }
          __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error(error.response.data.errors[prop][0], {
            title: "Error"
          });
        }
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Request failed with status code " + error.response.status, { title: "Error" });
    }
  } else if (error.request) {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something wrong with request messages.", {
      title: "Error"
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_2__main__["default"].$notification.error("Something went wrong, please try again later.", {
      title: "Error"
    });
  }

  return {
    isSuccess: false
  };
};

var syncApi = {
  get: function get(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  post: function post(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  put: function put(url, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  delete: function _delete(url, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  getWithOptions: function getWithOptions(url, option, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  postWithOptions: function postWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  },
  putWithOptions: function putWithOptions(url, option, payload, onBeginCallback, onFinallyCallback) {
    _guardCallback(onBeginCallback);

    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return _onError(error);
    }).finally(function () {
      _guardCallback(onFinallyCallback);
    });
  }
};

var asyncApi = {
  get: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              _guardCallback(onBeginCallback);
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url);

            case 4:
              response = _context.sent;
              return _context.abrupt("return", response.data);

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", _onError(_context.t0));

            case 11:
              _context.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 8, 11, 14]]);
    }));

    return function get(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(),
  post: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              _guardCallback(onBeginCallback);
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload);

            case 4:
              response = _context2.sent;
              return _context2.abrupt("return", response.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return", onErrorCallback(_context2.t0.response.data));

            case 12:
              return _context2.abrupt("return", _onError(_context2.t0));

            case 13:
              _context2.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context2.finish(13);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[0, 8, 13, 16]]);
    }));

    return function post(_x4, _x5, _x6, _x7, _x8) {
      return _ref2.apply(this, arguments);
    };
  }(),
  put: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(url, payload, onBeginCallback, onFinallyCallback, onErrorCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              _guardCallback(onBeginCallback);
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload);

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);

              if (!(typeof onErrorCallback === "function")) {
                _context3.next = 12;
                break;
              }

              return _context3.abrupt("return", onErrorCallback(_context3.t0.response.data));

            case 12:
              return _context3.abrupt("return", _onError(_context3.t0));

            case 13:
              _context3.prev = 13;

              _guardCallback(onFinallyCallback);
              return _context3.finish(13);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[0, 8, 13, 16]]);
    }));

    return function put(_x9, _x10, _x11, _x12, _x13) {
      return _ref3.apply(this, arguments);
    };
  }(),
  delete: function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(url, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

              _guardCallback(onBeginCallback);
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url);

            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", _onError(_context4.t0));

            case 11:
              _context4.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context4.finish(11);

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this, [[0, 8, 11, 14]]);
    }));

    return function _delete(_x14, _x15, _x16) {
      return _ref4.apply(this, arguments);
    };
  }(),
  getWithOptions: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(url, option, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;

              _guardCallback(onBeginCallback);
              _context5.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url, option);

            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data);

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);
              return _context5.abrupt("return", _onError(_context5.t0));

            case 11:
              _context5.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context5.finish(11);

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this, [[0, 8, 11, 14]]);
    }));

    return function getWithOptions(_x17, _x18, _x19, _x20) {
      return _ref5.apply(this, arguments);
    };
  }(),
  postWithOptions: function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;

              _guardCallback(onBeginCallback);
              _context6.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, payload, option);

            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);
              return _context6.abrupt("return", _onError(_context6.t0));

            case 11:
              _context6.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context6.finish(11);

            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this, [[0, 8, 11, 14]]);
    }));

    return function postWithOptions(_x21, _x22, _x23, _x24, _x25) {
      return _ref6.apply(this, arguments);
    };
  }(),
  putWithOptions: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(url, option, payload, onBeginCallback, onFinallyCallback) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;

              _guardCallback(onBeginCallback);
              _context7.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, payload, option);

            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data);

            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              return _context7.abrupt("return", _onError(_context7.t0));

            case 11:
              _context7.prev = 11;

              _guardCallback(onFinallyCallback);
              return _context7.finish(11);

            case 14:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this, [[0, 8, 11, 14]]);
    }));

    return function putWithOptions(_x26, _x27, _x28, _x29, _x30) {
      return _ref7.apply(this, arguments);
    };
  }()
};



/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/companies';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list' + filter).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/active').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  create: function create(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  update: function update(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  changeStatus: function changeStatus(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/status', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  delete: function _delete(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + '/' + id).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(242);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(495);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(512), __esModule: true };

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(513);
module.exports = __webpack_require__(1).Object.entries;


/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(5);
var $entries = __webpack_require__(514)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(6);
var getKeys = __webpack_require__(19);
var toIObject = __webpack_require__(10);
var isEnum = __webpack_require__(27).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_apiService__ = __webpack_require__(500);




var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/providers';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ('/list' + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/active').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getAllActiveWoSubscriber: function getAllActiveWoSubscriber() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/activewosubscriber').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getMasterOperators: function getMasterOperators(onBeginCallback, onFinallyCallback) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt('return', __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* asyncApi */].get(endpoint + '/list/master-operator', onBeginCallback, onFinallyCallback));

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  create: function create(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  update: function update(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  delete: function _delete(id) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ('/' + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt('return', _context7.sent);

            case 3:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  uploadImage: function uploadImage(request) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + '/image', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt('return', _context8.sent);

            case 3:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  }
});

/***/ }),

/***/ 722:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_shop_report_tenantReportService_js__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_master_provider_providerService_js__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_master_company_companyService_js__ = __webpack_require__(505);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToExport: function isAllowToExport() {
      return this.allPermissions.includes("Export");
    },
    recordInfo: function recordInfo() {
      return this.requestParams.totalRecords > 1 ? this.requestParams.totalRecords + " Records" : this.requestParams.totalRecords + " Record";
    },
    isAirportType: function isAirportType() {
      return this.requestParams.serviceType === "AirportTransfer";
    },
    isHourlyType: function isHourlyType() {
      return this.requestParams.serviceType === "Rental";
    },
    queryParams: function queryParams() {
      return {
        companyIds: this.requestParams.companyIds,
        serviceType: this.requestParams.serviceType,
        keyword: this.requestParams.keyword,
        status: this.requestParams.status,
        paymentStatus: this.requestParams.paymentStatus,
        progress: this.requestParams.progress,
        pickupDate: this.requestParams.pickupDate,
        sortBy: this.requestParams.sortBy,
        sortDirection: this.requestParams.sortDirection,
        sort: this.requestParams.sort,
        page: this.requestParams.page,
        pageSize: this.requestParams.pageSize
      };
    },
    queryParamsString: function queryParamsString() {
      var paramsString = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default()(this.queryParams).filter(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return value !== null && value !== undefined && value !== "Unspecified" && value !== "" && key !== "totalPages" && key !== "totalRecords";
      }).map(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        if (key === "pickupDate") {
          return "pickupFromDate=" + encodeURIComponent(value.start) + "&pickupToDate=" + encodeURIComponent(value.end);
        } else {
          return key + "=" + encodeURIComponent(value);
        }
      }).join("&");

      return paramsString.length > 0 ? "?" + paramsString : "";
    },
    generateQueryParams: function generateQueryParams() {
      var queryParams = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default()(this.exportParam).filter(function (_ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            key = _ref6[0],
            value = _ref6[1];

        return value !== null && value !== undefined && value !== "Unspecified" && value !== "" && key !== "filterType" && key !== "filterDate";
      }).map(function (_ref7) {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
            key = _ref8[0],
            value = _ref8[1];

        if (key === "pickupRange") {
          return "pickupFromDate=" + encodeURIComponent(value.start) + "&pickupToDate=" + encodeURIComponent(value.end);
        } else if (key === "reservationRange") {
          return "reservationFromDate=" + encodeURIComponent(value.start) + "&reservationToDate=" + encodeURIComponent(value.end);
        } else if (Array.isArray(value)) {
          if (value.length) {
            var x = "";
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                x += "&" + key + "=" + encodeURIComponent(item.id);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            return x.slice(1);
          }
        } else if (key === "sortDirection") {
          if (value) {
            return key + "=" + encodeURIComponent("desc");
          }
          return key + "=" + encodeURIComponent("asc");
        } else {
          return key + "=" + encodeURIComponent(value);
        }
      }).filter(function (val) {
        return val !== undefined;
      }).join("&");

      return "?" + queryParams;
    }
  },
  data: function data() {
    return {
      validationErrors: {
        status: null,
        paymentStatus: null,
        progressType: null,
        sortby: null,
        filter: null
      },
      exportParam: {
        filterDate: null,
        pickupRange: null,
        reservationRange: null,
        status: null,
        paymentStatus: null,
        progress: null,
        sortBy: null,
        sortDirection: false,
        filterType: null,
        providerIds: [],
        bookerCompanyIds: [],
        passengerCompanyIds: []
      },
      filters: [],
      providers: [],
      companies: [],
      paymentStatus: [],
      statusTypes: [],
      progressTypes: [],
      sortBy: [],
      filterDateOption: [],
      rentalLabel: null,
      airportLabel: null,
      allPermissions: [],
      items: [],
      isLoading: false,
      msg: "Please wait",
      requestParams: {
        companyIds: null,
        keyword: "",
        serviceType: "Unspecified",
        status: "",
        paymentStatus: "",
        progress: "",
        pickupDate: null,
        sortBy: "nearest_pickup_date",
        sortDirection: "asc",
        sort: "nearest_pickup_date_asc",
        page: 1,
        pageSize: 25,
        totalPages: 1,
        totalRecords: 0
      },
      sortByOption: [{
        value: "nearest_pickup_date_asc",
        label: "Nearest Pick-up Date"
      }, {
        value: "pickup_date_desc",
        label: "Latest Pick-up Date"
      }, {
        value: "pickup_date_asc",
        label: "Oldest Pick-up Date"
      }, {
        value: "reservation_date_desc",
        label: "Latest Reservation Date"
      }, {
        value: "reservation_date_asc",
        label: "Oldest Reservation Date"
      }],
      pageSizeOption: [25, 50, 100]
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var publicSettings, profile, permissions;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              _context.next = 3;
              return _this.$store.dispatch("setting/getAllPublic");

            case 3:
              publicSettings = _context.sent;

              _this.rentalLabel = _this.$helper.extractSetting(publicSettings, "RentalLabel", "Hourly");
              _this.airportLabel = _this.$helper.extractSetting(publicSettings, "AirportLabel", "Airport");

              _this.setupRequestParams();

              _context.next = 9;
              return _this.$store.dispatch("user/getProfile");

            case 9:
              profile = _context.sent;
              permissions = profile.services[_this.$route.name];

              if (permissions) {
                _this.allPermissions = permissions;
              }

              if (!_this.isAllowToRead) {
                _context.next = 23;
                break;
              }

              _this.statusTypes = [{ value: "Tentative", text: "Tentative" }, { value: "Confirmed", text: "Confirmed" }, { value: "Cancelled", text: "Cancelled" }];

              _this.paymentStatus = [{ value: "MonthlyInvoice", text: "Monthly Invoice" }, { value: "Completed", text: "Completed" }];

              _this.progressTypes = [{ value: "Pending", text: "Pending" }, { value: "Run", text: "Run" }, { value: "Done", text: "Done" }, { value: "UnderReview", text: "Under Review" }, { value: "Closed", text: "Closed" }, { value: "Rescue", text: "Rescue" }];

              _this.sortBy = [{ value: "pickup_date", text: "Pick-Up Date" }, { value: "reservation_date", text: "Reservation Date" }];

              _this.filters = [{ value: "None", text: "None" }, { value: "Provider", text: "Provider" }, { value: "Booker", text: "Booker" }, { value: "Passenger", text: "Passenger" }];

              _this.filterDateOption = [{ value: "Pick-Up Date", text: "Pick-Up Date" }, { value: "Reservation Date", text: "Reservation Date" }];

              _this.getProviders();
              _context.next = 22;
              return _this.getCompanies();

            case 22:
              _this.getReportList();

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    document.addEventListener("keydown", this.handleEnter);
  },
  updated: function updated() {
    this.$helper.collapseMenu("booking-history");
    this.$helper.setNavigationClass("tenant-report-link");

    $(".help-tip").popover({ trigger: "hover" });
  },

  methods: {
    handleEnter: function handleEnter(e) {
      if (e.key !== "Enter") return;
      if (document.body.classList.contains("modal-open")) {
        return;
      }

      e.preventDefault();
      this.onSearchReportList(true);
    },
    setupRequestParams: function setupRequestParams() {
      this.requestParams.companyIds = this.$route.query.companyIds || null;
      this.requestParams.page = Number(this.$route.query.page) || 1;
      this.requestParams.pageSize = this.$route.query.pageSize || 25;
      this.requestParams.keyword = this.$route.query.keyword || "";
      this.requestParams.sortBy = this.$route.query.sortBy || "nearest_pickup_date";
      this.requestParams.sortDirection = this.$route.query.sortDirection || "asc";
      this.requestParams.sort = this.$route.query.sort || "nearest_pickup_date_asc";
      this.requestParams.status = this.$route.query.status || null;
      this.requestParams.paymentStatus = this.$route.query.paymentStatus || null;
      this.requestParams.progress = this.$route.query.progress || null;
      this.requestParams.serviceType = this.$route.query.serviceType || "Unspecified";
      this.requestParams.pickupDate = this.$route.query.pickupFromDate && this.$route.query.pickupToDate ? {
        start: this.$route.query.pickupFromDate,
        end: this.$route.query.pickupToDate
      } : null;
    },
    getReportList: function getReportList() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isLoading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_shop_report_tenantReportService_js__["a" /* default */].getReportList(_this2.queryParamsString);

              case 4:
                response = _context2.sent;

                if (!(response.data == null)) {
                  _context2.next = 9;
                  break;
                }

                _this2.$notification.error("No reservation found", { title: "Error" });
                _this2.items = [];
                return _context2.abrupt("return");

              case 9:
                _this2.items = response.data.items;
                _this2.requestParams.totalPages = response.data.totalPages;
                _this2.requestParams.totalRecords = response.data.totalItems;
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](1);

                if (_context2.t0.errors) {
                  for (index = 0; index < _context2.t0.errors.length; index++) {
                    _this2.$notification.error(_context2.t0.errors[index], { title: "Error" });
                  }
                }

              case 17:
                _context2.prev = 17;

                _this2.isLoading = false;
                return _context2.finish(17);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 14, 17, 20]]);
      }))();
    },
    onChangeServiceType: function onChangeServiceType(value) {
      this.requestParams.serviceType = value;

      this.onSearchReportList();
    },
    onSelectSort: function onSelectSort(value) {
      if (value.includes("reservation")) {
        this.requestParams.sortBy = "reservation_date";

        if (value.includes("_asc")) {
          this.requestParams.sortDirection = "asc";
        } else {
          this.requestParams.sortDirection = "desc";
        }
      }

      if (value.includes("pickup")) {
        if (value === "nearest_pickup_date_asc") {
          this.requestParams.sortBy = "nearest_pickup_date";
        } else {
          this.requestParams.sortBy = "pickup_date";
        }

        if (value.includes("_asc")) {
          this.requestParams.sortDirection = "asc";
        } else {
          this.requestParams.sortDirection = "desc";
        }
      }

      this.onSearchReportList();
    },
    onSearchReportList: function onSearchReportList() {
      var fromFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (fromFilter) this.requestParams.page = 1;
      var path = "/report/tenant" + this.queryParamsString;
      if (this.$route.path !== path) this.$router.push(path);
    },
    resertFilter: function resertFilter() {
      var _extends2;

      this.requestParams = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.requestParams, (_extends2 = {
        keyword: "",
        companyIds: null
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, "keyword", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, "paymentStatus", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, "status", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, "progress", ""), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, "pickupDate", null), _extends2));

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$route.query).length > 0) {
        this.$router.replace("/report/tenant");
      }
    },
    onChangePageSize: function onChangePageSize() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.onSearchReportList();

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    onNavigateCallback: function onNavigateCallback(pageNumber) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.requestParams.page = pageNumber;
                _this4.onSearchReportList();

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    getProviders: function getProviders() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__services_master_provider_providerService_js__["a" /* default */].getAllActive();

              case 2:
                _this5.providers = _context5.sent;

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    getCompanies: function getCompanies() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return __WEBPACK_IMPORTED_MODULE_10__services_master_company_companyService_js__["a" /* default */].getAllActive();

              case 2:
                _this6.companies = _context6.sent;

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    open: function open(reservation) {
      var pathUrl = "/reservation/inquiry/";
      var routeData = this.$router.resolve({
        path: pathUrl + reservation.id
      });
      window.open(routeData.href, "_blank");
    },
    onChangeFilterDate: function onChangeFilterDate(value) {
      var thisMonth = new Date();
      var selectedDate = thisMonth.getMonth() + 1 + "/" + thisMonth.getDate() + "/" + thisMonth.getFullYear();

      if (value === "Pick-Up Date") {
        this.exportParam.reservationRange = null;
        this.exportParam.pickupRange = {
          start: selectedDate,
          end: selectedDate
        };
      }

      if (value === "Reservation Date") {
        this.exportParam.pickupRange = null;
        this.exportParam.reservationRange = {
          start: selectedDate,
          end: selectedDate
        };
      }
    },
    openExportModal: function openExportModal() {
      var thisMonth = new Date();
      var selectedDate = thisMonth.getMonth() + 1 + "/" + thisMonth.getDate() + "/" + thisMonth.getFullYear();
      this.exportParam.pickupRange = {
        start: selectedDate,
        end: selectedDate
      };
      this.exportParam.filterDate = "Pick-Up Date";
      this.exportParam.sortBy = "pickup_date";
      this.exportParam.filterType = "None";
      this.exportParam.providerIds = [];
      this.exportParam.bookerCompanyIds = [];
      this.exportParam.passengerCompanyIds = [];
      $(this.$refs.exportmodal).modal({ backdrop: "static", keyboard: false });
    },
    exportToExcel: function exportToExcel() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response, link, index;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this7.isLoading = true;
                _context7.prev = 1;
                _context7.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_shop_report_tenantReportService_js__["a" /* default */].exportReportToExcel(_this7.generateQueryParams);

              case 4:
                response = _context7.sent;


                if (response.data.isReportExist) {
                  link = document.createElement("a");

                  link.href = "data:application/octet-stream;charset=utf-8;base64," + response.data.content;
                  link.target = "_blank";
                  link.download = response.data.name + ".xlsx";
                  link.click();
                } else {
                  _this7.$notification.warning("Report not found", { title: "Warning" });
                }
                _context7.next = 11;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](1);

                if (_context7.t0.errors) {
                  for (index = 0; index < _context7.t0.errors.length; index++) {
                    _this7.$notification.error(_context7.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context7.prev = 11;

                _this7.isLoading = false;
                return _context7.finish(11);

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[1, 8, 11, 14]]);
      }))();
    },
    isAirportTransfer: function isAirportTransfer(serviceType) {
      return serviceType.toLowerCase() === "airporttransfer";
    },
    humanize: function humanize(value) {
      return this.$helper.humanize(value);
    },
    changeStatusFilter: function changeStatusFilter() {
      if (this.requestParams.status === "Cancelled") {
        this.requestParams.progress = "";
      }

      if (this.requestParams.status === "Tentative") {
        this.requestParams.paymentStatus = "";
      }
    },
    changeStatusExport: function changeStatusExport() {
      if (this.exportParam.status === "Cancelled") {
        this.exportParam.progress = "";
      }

      if (this.exportParam.status === "Tentative") {
        this.exportParam.paymentStatus = "";
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener("keydown", this.handleEnter);
  },

  watch: {
    "$route.params": {
      deep: true,
      handler: function handler(value) {
        this.getReportList();
      }
    }
  }
});

/***/ }),

/***/ 885:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/shop/reports/tenant";

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/list" + (filter + "&sortDir=desc&sort=ReservationDate")).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getReportList: function getReportList() {
    var _this2 = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/search" + params).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  exportReportToExcel: function exportReportToExcel(params) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/export/excel" + params).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  exportToExcel: function exportToExcel(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/export/xls", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  }
});

/***/ }),

/***/ 886:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section-header-info"},[_c('div',{staticClass:"container big-container"},[_c('div',{staticClass:"row mt-20"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"content-header-info"},[_c('div',{staticClass:"col-sm-12"},[(_vm.isAllowToExport)?_c('button',{staticClass:"btn btn-primary pull-left",on:{"click":function($event){return _vm.openExportModal()}}},[_vm._m(0),_vm._v("Export\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pl-30 pull-left"},[_c('h2',[_vm._v("\n                  "+_vm._s(_vm.rentalLabel)+" & "+_vm._s(_vm.airportLabel)+" Bookings\n                  "),_vm._m(1)]),_vm._v(" "),_c('p',[_vm._v("Manage and view all transactions.")])])])])])])])]),_vm._v(" "),_c('section',[_c('div',{staticClass:"container big-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"btn-group mb-15",attrs:{"role":"group","aria-label":"..."}},[_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': !_vm.isAirportType && !_vm.isHourlyType },attrs:{"type":"button"},on:{"click":function($event){return _vm.onChangeServiceType('Unspecified')}}},[_vm._v("\n                All\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.isAirportType },attrs:{"type":"button"},on:{"click":function($event){return _vm.onChangeServiceType('AirportTransfer')}}},[_vm._v("\n                Airport Transfer\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'btn-active': _vm.isHourlyType },attrs:{"type":"button"},on:{"click":function($event){return _vm.onChangeServiceType('Rental')}}},[_vm._v("\n                Hourly\n              ")])])])])])])]),_vm._v(" "),_c('section',{staticClass:"middle-content"},[_c('div',{staticClass:"container big-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('label',{attrs:{"for":"search"}},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"dataTables_filter",attrs:{"id":"filter-search"}},[_c('i',{staticClass:"ic-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.requestParams.keyword),expression:"requestParams.keyword"}],staticClass:"form-control",attrs:{"id":"search","type":"search","placeholder":"Search"},domProps:{"value":(_vm.requestParams.keyword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.requestParams, "keyword", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',[_vm._v("Pickup Date")]),_vm._v(" "),_c('div',{staticClass:"dataTables_filter"},[_c('i',{staticClass:"ic-date-picker"}),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"mutation-start-pickup","color":"#025BC5","format":"MM/DD/YYYY","formatted":"LL","range":"","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.requestParams.pickupDate),callback:function ($$v) {_vm.$set(_vm.requestParams, "pickupDate", $$v)},expression:"requestParams.pickupDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',[_vm._v("Reservation Status")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Status","label":"text","options":_vm.statusTypes,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},on:{"input":function($event){return _vm.changeStatusFilter()}},model:{value:(_vm.requestParams.status),callback:function ($$v) {_vm.$set(_vm.requestParams, "status", $$v)},expression:"requestParams.status"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4",staticStyle:{"margin-top":"20px"}},[_c('label',{attrs:{"for":"search"}},[_vm._v("Payment Status")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Payment Status","label":"text","options":_vm.paymentStatus,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; },"disabled":_vm.requestParams.status === 'Tentative'},model:{value:(_vm.requestParams.paymentStatus),callback:function ($$v) {_vm.$set(_vm.requestParams, "paymentStatus", $$v)},expression:"requestParams.paymentStatus"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4",staticStyle:{"margin-top":"20px"}},[_c('label',[_vm._v("Progress")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Progress","label":"text","options":_vm.progressTypes,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; },"disabled":_vm.requestParams.status === 'Cancelled'},model:{value:(_vm.requestParams.progress),callback:function ($$v) {_vm.$set(_vm.requestParams, "progress", $$v)},expression:"requestParams.progress"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4",staticStyle:{"margin-top":"20px"}},[_c('label',[_vm._v("Company")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Company","label":"name","options":_vm.companies,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; }},model:{value:(_vm.requestParams.companyIds),callback:function ($$v) {_vm.$set(_vm.requestParams, "companyIds", $$v)},expression:"requestParams.companyIds"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-5",staticStyle:{"margin-top":"25px"}},[_c('div',{staticClass:"dataTables_filter"},[_c('div',{staticClass:"d-flex",staticStyle:{"gap":"10px"}},[_c('button',{staticClass:"search-button",on:{"click":function($event){return _vm.onSearchReportList(true)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 20 20"}},[_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M8.5 3a5.5 5.5 0 0 1 4.383 8.823l4.147 4.147a.75.75 0 0 1-.976 1.133l-.084-.073l-4.147-4.147A5.5 5.5 0 1 1 8.5 3zm0 1.5a4 4 0 1 0 0 8a4 4 0 0 0 0-8z","fill":"currentColor"}})])]),_vm._v("\n                Search\n              ")]),_vm._v(" "),_c('button',{staticClass:"clear-button",on:{"click":function($event){return _vm.resertFilter()}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34z","fill":"currentColor"}})]),_vm._v("\n                Clear All\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7",staticStyle:{"margin-top":"25px"}},[_c('div',{staticClass:"dataTables_length"},[_c('label',[_c('span',[_vm._v("Sort by: ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.requestParams.sort),expression:"requestParams.sort"}],staticClass:"form-control v-select",staticStyle:{"width":"250px"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.requestParams, "sort", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function (e) { return _vm.onSelectSort(e.target.value); }]}},_vm._l((_vm.sortByOption),function(item){return _c('option',{key:item.value,domProps:{"value":item.value}},[_vm._v("\n                  "+_vm._s(item.label)+"\n                ")])}),0)]),_vm._v(" "),_c('label',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.requestParams.pageSize),expression:"requestParams.pageSize"}],staticClass:"form-control v-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.requestParams, "pageSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onChangePageSize()}]}},_vm._l((_vm.pageSizeOption),function(item){return _c('option',{key:item,domProps:{"value":item}},[_vm._v("\n                  "+_vm._s(item)+"\n                ")])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"table-responsive table-manage"},[_c('table',{staticClass:"table table-hover"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.id,staticClass:"detail-row"},[_c('td',{staticClass:"text-center"},[_c('strong',[(
                          _vm.isAirportTransfer(item.serviceType) &&
                          item.pickUpLocation.isAirportZone
                        )?_c('i',{staticClass:"ic-flight-icon"}):(
                          _vm.isAirportTransfer(item.serviceType) &&
                          item.dropOffLocation.isAirportZone
                        )?_c('i',{staticClass:"ic-flight-departure-icon"}):(
                          _vm.isAirportTransfer(item.serviceType) &&
                          !item.pickUpLocation.isAirportZone &&
                          !item.dropOffLocation.isAirportZone
                        )?_c('i',{staticClass:"ic-car-alt"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 1200 1200"}},[_c('path',{attrs:{"fill":"currentColor","d":"m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"}})])]):_c('i',{staticClass:"ic-time"})])]),_vm._v(" "),_c('td',[(item.isError)?_c('span',{staticClass:"help-tip cursor-pointer",attrs:{"tabindex":"0","data-container":"body","data-toggle":"popover","data-placement":"top","data-content":item.errorMessage ? item.errorMessage : '  '}},[_vm._v("\n                      !\n                    ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"view-detail-link",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){$event.preventDefault();return _vm.open(item)}}},[_vm._v("\n                      "+_vm._s(item.code)+"\n                    ")])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.booker.company))]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                      "+_vm._s(item.booker.title ? ((item.booker.title) + ".") : "")+"\n                      "+_vm._s(item.booker.fullName)+"\n                    ")])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(item.passenger.company))]),_vm._v(" "),_c('span',{staticClass:"new-line"},[_vm._v("\n                      "+_vm._s(item.passenger.title ? ((item.passenger.title) + ".") : "")+"\n                      "+_vm._s(item.passenger.fullName)+"\n                    ")])]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(item.vehicle.className)+"\n                    "),(item.vehicle)?_c('span',[_c('span',{staticClass:"new-line"},[_vm._v("\n                        "+_vm._s(item.vehicle.factoryName)+"\n                        "+_vm._s(item.vehicle.brandName)+"\n                      ")]),_vm._v(" "),(item.vehicle.plateNumber)?_c('span',{staticClass:"new-line"},[_vm._v("\n                        ("+_vm._s(item.vehicle.plateNumber)+")\n                      ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(_vm.$helper.dateFormatted(item.originalPickUpTime.dateTime))+"\n                    "),_c('strong',[_vm._v(_vm._s(_vm.$helper.timeFormatted(item.originalPickUpTime.dateTime)))]),_vm._v(" "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.originalPickUpTime.timezone)+")")])]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(_vm.$helper.dateFormatted(item.pickUpDate.dateTime))+"\n                    "),_c('strong',[_vm._v(_vm._s(_vm.$helper.timeFormatted(item.pickUpDate.dateTime)))]),_vm._v(" "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.pickUpDate.timezone)+")")])]),_vm._v(" "),_c('td',[_vm._v("\n                    "+_vm._s(_vm.$helper.dateFormatted(item.dropOffDate.dateTime))+"\n                    "),_c('strong',[_vm._v(_vm._s(_vm.$helper.timeFormatted(item.dropOffDate.dateTime)))]),_vm._v(" "),_c('span',{staticClass:"utc-style"},[_vm._v("("+_vm._s(item.dropOffDate.timezone)+")")])]),_vm._v(" "),_c('td',{class:{
                      '--green35':
                        item.paymentStatus === 'Complete' ||
                        item.paymentStatus === 'Refunded',
                      'sts-danger':
                        item.paymentStatus === 'Unpaid' ||
                        item.paymentStatus === 'RefundRequested',
                    },staticStyle:{"display":"text-inline"}},[_vm._v("\n                    "+_vm._s(item.paymentStatus === "Complete"
                        ? "Completed"
                        : _vm.humanize(item.paymentStatus))+"\n                    "),(item.paymentInfo === 'Monthly Invoice')?_c('span',{staticStyle:{"color":"#212121"}},[_vm._v("("+_vm._s(item.paymentInfo)+")")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{class:{
                        'sts_job-open': item.progress === 'Open',
                        'sts_job-run': item.progress === 'Run',
                        'sts_job-done': item.progress === 'Done',
                        'sts_job-closed': item.progress === 'Close',
                        'sts_job-aborted': item.progress === 'Abort',
                        'sts_job-rescue_operation':
                          item.progress === 'RescueOperation',
                        'sts_job-under-review':
                          item.progress === 'UnderReview',
                      }})]),_vm._v(" "),_c('td',{staticClass:"text-right"},[(item.rates.buying)?_c('span',[_vm._v(_vm._s(item.rates.currencyCode)+"\n                      "+_vm._s(_vm.$currencyFormat(
                          item.rates.currencyCode,
                          item.rates.buying
                        ))+"\n                    ")]):_c('span',{staticClass:"sts-danger"},[_vm._v("N/A")])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(item.rates.currencyCode)+"\n                    "+_vm._s(_vm.$currencyFormat(
                        item.rates.currencyCode,
                        item.rates.selling
                      ))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                    "+_vm._s(item.rates.currencyCode)+"\n                    "+_vm._s(_vm.$currencyFormat(
                        item.rates.currencyCode,
                        item.rates.incentive
                      ))+"\n                  ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[(item.rates.buying)?_c('span',[_vm._v(_vm._s(item.rates.currencyCode)+"\n                      "+_vm._s(_vm.$currencyFormat(
                          item.rates.currencyCode,
                          item.rates.profit
                        )))]):_c('span',{staticClass:"sts-danger"},[_vm._v("N/A")])])])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"dataTables_info --blue25"},[_c('strong',[_vm._v(_vm._s(_vm.recordInfo))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('nav',{attrs:{"aria-label":"..."}},[_c('paginate',{attrs:{"page-count":_vm.requestParams.totalPages,"click-handler":_vm.onNavigateCallback,"prev-text":'Previous',"next-text":'Next',"container-class":'pagination pull-right'},model:{value:(_vm.requestParams.page),callback:function ($$v) {_vm.$set(_vm.requestParams, "page", $$v)},expression:"requestParams.page"}})],1)])])])]),_vm._v(" "),_c('div',{ref:"exportmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[_c('form',{attrs:{"action":"#","id":"vueform","role":"form"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Filter Date")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"","label":"text","options":_vm.filterDateOption,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},on:{"input":function (value) { return _vm.onChangeFilterDate(value); }},model:{value:(_vm.exportParam.filterDate),callback:function ($$v) {_vm.$set(_vm.exportParam, "filterDate", $$v)},expression:"exportParam.filterDate"}})],1),_vm._v(" "),(this.exportParam.filterDate === 'Pick-Up Date')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Pick-up Range")]),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"mutation-start","color":"#025BC5","format":"MM/DD/YYYY","formatted":"LL","range":"","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.exportParam.pickupRange),callback:function ($$v) {_vm.$set(_vm.exportParam, "pickupRange", $$v)},expression:"exportParam.pickupRange"}})],1):_vm._e(),_vm._v(" "),(this.exportParam.filterDate === 'Reservation Date')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Reservation Range")]),_vm._v(" "),_c('VueCtkDateTimePicker',{attrs:{"id":"mutation-start","color":"#025BC5","format":"MM/DD/YYYY","formatted":"LL","range":"","auto-close":"","only-date":"","no-label":"","no-header":"","no-button":"","no-button-now":""},model:{value:(_vm.exportParam.reservationRange),callback:function ($$v) {_vm.$set(_vm.exportParam, "reservationRange", $$v)},expression:"exportParam.reservationRange"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Reservation Status")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Status","label":"text","options":_vm.statusTypes,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},on:{"input":function($event){return _vm.changeStatusExport()}},scopedSlots:_vm._u([{key:"search",fn:function(ref){
                        var attributes = ref.attributes;
                        var events = ref.events;
return [_c('input',_vm._g(_vm._b({staticClass:"vs__search",attrs:{"name":"statusType","required":!_vm.exportParam.status}},'input',attributes,false),events))]}}]),model:{value:(_vm.exportParam.status),callback:function ($$v) {_vm.$set(_vm.exportParam, "status", $$v)},expression:"exportParam.status"}}),_vm._v(" "),(_vm.validationErrors.status)?_c('small',{staticClass:"form-text text-danger",domProps:{"textContent":_vm._s(_vm.validationErrors.status)}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Payment Status")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Payment Status","label":"text","options":_vm.paymentStatus,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; },"disabled":_vm.exportParam.status === 'Tentative'},scopedSlots:_vm._u([{key:"search",fn:function(ref){
                        var attributes = ref.attributes;
                        var events = ref.events;
return [_c('input',_vm._g(_vm._b({staticClass:"vs__search",attrs:{"name":"paymentStatus","required":!_vm.exportParam.paymentStatus}},'input',attributes,false),events))]}}]),model:{value:(_vm.exportParam.paymentStatus),callback:function ($$v) {_vm.$set(_vm.exportParam, "paymentStatus", $$v)},expression:"exportParam.paymentStatus"}}),_vm._v(" "),(_vm.validationErrors.paymentStatus)?_c('small',{staticClass:"form-text text-danger",domProps:{"textContent":_vm._s(_vm.validationErrors.paymentStatus)}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Progress Type")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Progress","label":"text","options":_vm.progressTypes,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; },"disabled":_vm.exportParam.status === 'Cancelled'},scopedSlots:_vm._u([{key:"search",fn:function(ref){
                        var attributes = ref.attributes;
                        var events = ref.events;
return [_c('input',_vm._g(_vm._b({staticClass:"vs__search",attrs:{"name":"progressType","required":!_vm.exportParam.progressType}},'input',attributes,false),events))]}}]),model:{value:(_vm.exportParam.progress),callback:function ($$v) {_vm.$set(_vm.exportParam, "progress", $$v)},expression:"exportParam.progress"}}),_vm._v(" "),(_vm.validationErrors.progressType)?_c('small',{staticClass:"form-text text-danger",domProps:{"textContent":_vm._s(_vm.validationErrors.progressType)}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',[_vm._v("Sort")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"","label":"text","options":_vm.sortBy,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},scopedSlots:_vm._u([{key:"search",fn:function(ref){
                        var attributes = ref.attributes;
                        var events = ref.events;
return [_c('input',_vm._g(_vm._b({staticClass:"vs__search",attrs:{"name":"sortBy","required":!_vm.exportParam.sortBy}},'input',attributes,false),events))]}}]),model:{value:(_vm.exportParam.sortBy),callback:function ($$v) {_vm.$set(_vm.exportParam, "sortBy", $$v)},expression:"exportParam.sortBy"}}),_vm._v(" "),(_vm.validationErrors.sortBy)?_c('small',{staticClass:"form-text text-danger",domProps:{"textContent":_vm._s(_vm.validationErrors.sortBy)}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"d-flex"},[_c('label',{staticClass:"cursor-pointer mb-0 mt-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.exportParam.sortDirection),expression:"exportParam.sortDirection"}],staticClass:"control-radio",attrs:{"type":"radio","value":"true"},domProps:{"checked":_vm.exportParam.sortDirection == true,"checked":_vm._q(_vm.exportParam.sortDirection,"true")},on:{"change":function($event){return _vm.$set(_vm.exportParam, "sortDirection", "true")}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("Oldest")])]),_vm._v(" "),_c('label',{staticClass:"cursor-pointer mb-0 mt-5 pl-20"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.exportParam.sortDirection),expression:"exportParam.sortDirection"}],staticClass:"control-radio",attrs:{"type":"radio","value":"false"},domProps:{"checked":_vm.exportParam.sortDirection == false,"checked":_vm._q(_vm.exportParam.sortDirection,"false")},on:{"change":function($event){return _vm.$set(_vm.exportParam, "sortDirection", "false")}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("Newest")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Filter")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"","label":"text","options":_vm.filters,"clearable":false,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},model:{value:(_vm.exportParam.filterType),callback:function ($$v) {_vm.$set(_vm.exportParam, "filterType", $$v)},expression:"exportParam.filterType"}})],1),_vm._v(" "),(_vm.exportParam.filterType === 'Provider')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.exportParam.filterType))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.providers,"multiple":true,"close-on-select":false,"limit":1,"placeholder":"Select provider","label":"name","track-by":"id"},model:{value:(_vm.exportParam.providerIds),callback:function ($$v) {_vm.$set(_vm.exportParam, "providerIds", $$v)},expression:"exportParam.providerIds"}})],1):_vm._e(),_vm._v(" "),(_vm.exportParam.filterType === 'Booker')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Company's "+_vm._s(_vm.exportParam.filterType))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.companies,"multiple":true,"close-on-select":false,"limit":1,"placeholder":"Select booker","label":"name","track-by":"id"},model:{value:(_vm.exportParam.bookerCompanyIds),callback:function ($$v) {_vm.$set(_vm.exportParam, "bookerCompanyIds", $$v)},expression:"exportParam.bookerCompanyIds"}})],1):_vm._e(),_vm._v(" "),(_vm.exportParam.filterType === 'Passenger')?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Company's "+_vm._s(_vm.exportParam.filterType))]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.companies,"multiple":true,"close-on-select":false,"limit":1,"placeholder":"Select passenger","label":"name","track-by":"id"},model:{value:(_vm.exportParam.passengerCompanyIds),callback:function ($$v) {_vm.$set(_vm.exportParam, "passengerCompanyIds", $$v)},expression:"exportParam.passengerCompanyIds"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.exportToExcel()}}},[_vm._v("\n                      Export\n                    ")])])])])])])])])])]),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"ic-download"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"ic-booking-history"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Code")]),_vm._v(" "),_c('th',[_vm._v("Booker")]),_vm._v(" "),_c('th',[_vm._v("Passenger")]),_vm._v(" "),_c('th',[_vm._v("Vehicle")]),_vm._v(" "),_c('th',{staticClass:"single-line-text"},[_vm._v("Reservation Pick-up")]),_vm._v(" "),_c('th',[_vm._v("Pick-Up")]),_vm._v(" "),_c('th',[_vm._v("Drop-Off")]),_vm._v(" "),_c('th',[_vm._v("Payment")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Progress")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Buying")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Selling")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Incentive")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Profit")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Export Report")]),_vm._v(" "),_c('h6',[_vm._v("Please fill all information below.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/54.c3389927a414072c8924.js